import { inject, Injectable } from '@angular/core';

import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly keycloak = inject(Keycloak);

  isAuthorized(restrictedPermission: Array<string> | string): boolean {
    if (!Array.isArray(restrictedPermission)) restrictedPermission = [restrictedPermission];

    return restrictedPermission.some((role) => this.keycloak.hasRealmRole(role));
  }

  logout(): void {
    this.keycloak.logout();
  }
}
